module.exports = __webpack_public_path__ + "static/michelin-72f561a1e08d342f33994e78ab11685b.png";